import { CommentIcon } from '@primer/octicons-react';
import { graphql, useFragment } from 'react-relay';

import { BrandMessagePreview_brandMessagePreview$key } from '../../../relay/__generated__/BrandMessagePreview_brandMessagePreview.graphql';
import Stack from '../../core/Stack';
import StyledOcticon from '../../core/StyledOcticon';
import Text from '../../core/Text';
import View from '../../core/View';
import BrandMessageTemplatePreview from '../../brandMessageTemplate/BrandMessageTemplatePreview';

// 템플릿 미리보기와 같은 레이아웃으로 그리기 위해, 필드명을 BrandMessageTemplate 과 동일하게 맞춰
// 메시지 객체를 그대로 BrandMessageTemplatePreview 에 넘긴다.
// (커머스·캐러셀·리스트는 본문이 content 가 아니라 JSON 필드에 들어 있어 content 만으로는 못 그린다.)
const BrandMessagePreview_brandMessagePreview = graphql`
  fragment BrandMessagePreview_brandMessagePreview on BrandMessagePreview {
    messages {
      to

      chatBubbleType
      imageUrl
      imageLink
      content
      header
      additionalContent
      carousel
      wideItemList
      video
      commerce

      buttons {
        name
        linkType
        linkMobile
        linkIos
      }
      coupon {
        title
        description
        linkMobile
        linkPc
        linkAndroid
        linkIos
      }
    }
  }
`;

type Props = { hideTo?: boolean; brandMessagePreview: BrandMessagePreview_brandMessagePreview$key };
const BrandMessagePreview = ({ hideTo, brandMessagePreview: brandMesagePreviewReference }: Props) => {
  const brandMessagePreview = useFragment(BrandMessagePreview_brandMessagePreview, brandMesagePreviewReference);

  const firstPreview = brandMessagePreview.messages[0];

  if (!firstPreview) {
    return null;
  }
  const { to, ...message } = firstPreview;

  return (
    <View marginX={'auto'}>
      {hideTo ? null : (
        <View mb={1}>
          <Stack gapX={1}>
            <Stack.Item>
              <StyledOcticon icon={CommentIcon} size={16} />
            </Stack.Item>
            <Stack.Item>
              <Text fontSize={1}>{to}</Text>
            </Stack.Item>
          </Stack>
        </View>
      )}
      <BrandMessageTemplatePreview value={message} />
    </View>
  );
};

export default BrandMessagePreview;
